import React, { useState, useEffect, useRef } from 'react';
import {config} from "../../shared/config.js";
import * as util from '../../shared/commons.js';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../../shared/ShowError.jsx';
import Laoding from '../../shared/Laoding.jsx';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Dialog } from 'primereact/dialog';
import GeneralDialogFooter from '../../shared/GeneralDialogFooter.jsx';
import ShowConfirm from '../../shared/ShowConfirm.jsx';
import Table from 'react-bootstrap/Table';
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from 'primereact/checkbox';        
import { InputText } from 'primereact/inputtext';
import CityCombo from '../../combos/CityCombo.jsx';
import { FloatLabel } from 'primereact/floatlabel';
import FaDate from '../../shared/FaDate.jsx';
import { InputNumber } from 'primereact/inputnumber';
import UserTypeCombo from '../../combos/UserTypeCombo.jsx';
import * as XLSX from 'xlsx';

var editedModules = [];
var editedParameters = {};
export default function DiscountList(props) {
    const navigate = useNavigate();
    const dt = useRef(null);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [discounts, setDiscounts] = useState([]);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
    const [confirmResetPasswordVisible, setConfirmResetPasswordVisible] = useState(false);
    const [mobile, setMobile] = useState("");
    const [count, setCount] = useState(0);
    const [percent, setPercent] = useState(0);
    const [date, setDate] = useState(0);
    const [newDate, setNewDate] = useState(0);

    const [date2, setDate2] = useState(0);
    const [date3, setDate3] = useState(0);
    const [newDate2, setNewDate2] = useState(0);
    const [newDate3, setNewDate3] = useState(0);

    const [searchPanelVisible, setSearchPanelVisible] = useState(false);
    const [searchOptions, setSearchOptions] = useState({tokenCode:"", mobile:"", fromExpireDate:0, toExpireDate:0, fromPercent:0, toPercent:0, usedToType:0, discountTokenState:0});
    const [discountId, setDiscountId] = useState("");
    const [discountIndex, setDiscountIndex] = useState(-1);

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = function(){
        setLoading(true);
        var params = {
            login:util.getLoginDto(), 
            tokenCode:searchOptions.tokenCode,
            mobile:searchOptions.mobile,
            fromExpireDate:searchOptions.fromExpireDate,
            toExpireDate:searchOptions.toExpireDate,
            fromPercent:searchOptions.fromPercent,
            toPercent:searchOptions.toPercent,
            usedToType:searchOptions.usedToType,
            discountTokenState:searchOptions.discountTokenState,
            lastIndex:0,
            pageSize:0,
        };
        var url = config.Server+`/basic/discount-token/list`;
        console.log("params in show summary is>", params);
        console.log("url in show summary is>", url);
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("setDiscounts is> ", response);
                for(var i=0;i<response.length;i++){
                    
                }
                setDiscounts(response);
                setLoading(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
        console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });

    }
    const onAddNewItemClick = function(){
        setDiscountId("");
        setDiscountIndex(-1);
        setMobile("");
        setCount(0);
        setPercent(0);
        setEditFormVisible(true);
    }
    const setRowActions = function (row, cInd) {
        return (
        <Row className="justify-content-md-center" style={{}}>
            <Button icon="pi pi-trash" rounded severity="danger" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowDeleteClick(row, cInd)} title="حذف" />
        </Row>
        );
    }
    //=====================================================================================================================================
    //============                  user edit form                  =======================================================================
    //=====================================================================================================================================
    const checkDataEntry = function(){
        if(mobile != ""){
            var check = util.IsMobileValid(mobile);
            if(!check.valid){
                setErrorMessage(check.msg);
                setErorVisible(true);
                return false;
            }
        }
        if(count <= 0){
            setErrorMessage("تعداد کدهای تحفیف را مشخص کنید");
            setErorVisible(true);
            return false;
        }
        if(percent <= 0){
            setErrorMessage("درصد تخفیف را مشخص کنید");
            setErorVisible(true);
            return false;
        }
        if(newDate <= 0){
            setErrorMessage("تاریخ انقضاء را مشخص کنید");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveItem = function(){
        if(!checkDataEntry()) return;
        var url = config.Server + `/basic/discount-token/create`;
        var params = {
            login:util.getLoginDto(), 
            count:count,
            percent:percent,
            mobile:mobile,
            expireDate:newDate,
        };
        setSaving(true);
        console.log("user is>", params);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                var ncs = [...discounts];
                if(discountIndex == -1){ 
                    for(var i=0;i<response.length;i++)                   
                    ncs.push({...response[i]});                    
                }
                else{
                    ncs[discountIndex] = {...response};
                }
                setDiscounts(ncs);
                setSaving(false);
                setEditFormVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

    }
    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{setEditFormVisible(false)}} saving={saving} />
        )
    }
    //=====================================================================================================================================
    //============                  delete user                  =======================================================================
    //=====================================================================================================================================
    const onRowDeleteClick = function(user, cInd){
        setDiscountId(user.id);
        setDiscountIndex(cInd);
        setConfirmDeleteVisible(true);
    }
    const deleteItem = function(){
        setDeleting(true);
        var params = {login:util.getLoginDto(), id:discountId};
        var url = config.Server+`/basic/discount-token/delete`;
        axios
            .post(url, params )
            .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                var ncs = [...discounts];
                ncs.splice(discountIndex, 1);
                setDiscounts(ncs);

                setDeleting(false);
                setConfirmDeleteVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDeleting(false);
            }
            })
            .catch(error => {
                setDeleting(false);
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });
    }
    const onDeleteConfirm_Accept = function(){
      deleteItem();
    }
    const onDeleteConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteVisible(false);
    }

    const onCountChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setCount(v);
    }
    const onPercentChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setPercent(v);
    }
    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "mobile") setMobile(val);
    }
    const onSearchInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        var so = {...searchOptions};
        if((name === "mobile")||(name === "tokenCode")) so[name] = val;
        else if((name === "fromPercent")||(name === "toPercent")) {
            if(val == "") val = "0";
            so[name] = parseInt(val);
            if(name == "fromPercent") so["toPercent"] = parseInt(val);
        }
        else if((name === "fromExpireDate")||(name === "toExpireDate")) {
            if(val == "") val = "0";
            so[name] = parseInt(val);
            if(name == "fromExpireDate"){ 
                so["toExpireDate"] = parseInt(val);
                setDate3(parseInt(val))
            }
        }
        setSearchOptions(so);
    }

    const exportToExcel = () => {
        // ۱. گرفتن تمام داده‌ها از DataTable
        const data = [];
        for(var i=0;i<discounts.length;i++){
            data.push({
                mobile:discounts[i].toUserMobile, 
                percent:discounts[i].tokenPercent,
                code:discounts[i].tokenCode,
                expireDate:util.SeperateDate(discounts[i].expireDate),
                state:discounts[i].discountTokenState.title,
            });
        }
        const headerMapping = {
            mobile: 'موبایل',
            percent: 'درصد تخفیف',
            code: 'کد تخفیف',
            expireDate: 'تاریخ انقضاء',
            state: 'وضعیت'
        };        
        const dataWithPersianHeaders = data.map(item => ({
            'موبایل': item.mobile,
            'درصد تخفیف': item.percent,
            'کد تخفیف': item.code,
            'تاریخ انقضاء': item.expireDate,
            'وضعیت': item.state
        }));
        const ws = XLSX.utils.json_to_sheet(dataWithPersianHeaders);
        ws['!cols'] = [
            { wch: 20 },   
            { wch: 15 },   
            { wch: 30 },   
            { wch: 18 },   
            { wch: 15 }
        ];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "محصولات");
        XLSX.writeFile(wb, "لیست کد های تخفیف.xlsx");
    };

    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (loading)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت لیست کد های تخفیف..." />
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        <>
            
            
            <div style={{textAlign:"center", padding:"5px", backgroundColor:"#ccc", marginTop:"10px", borderTopRightRadius:"5px", borderTopLeftRadius:"5px"}}>
                لیست کد های تخفیف
            </div>
            {
              searchPanelVisible?
              <Row style={{border:"1px dashed #b0b0b0", padding:"5px", margin:"10px 0px 0px 0px"}}>
                <Col md={3} style={{marginTop:"20px"}}>
                    <FloatLabel>
                        <InputText value={searchOptions.tokenCode} onChange={(e)=>{onSearchInputChange(e, "tokenCode")}} id="tokenCode" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                        <label htmlFor="tokenCode">کد تخفیف</label>
                    </FloatLabel>                                                                      
                </Col>
                <Col md={3} style={{marginTop:"20px"}}>
                    <FloatLabel>
                        <InputText value={searchOptions.mobile} onChange={(e)=>{onSearchInputChange(e, "mobile")}} id="mobile" keyfilter="int" maxLength={11} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                        <label htmlFor="mobile">موبایل مشتری</label>
                    </FloatLabel>                                                                      
                </Col>
                <Col md={3} style={{marginTop:"20px"}}>
                    <FloatLabel>
                        <InputText value={searchOptions.fromPercent} onChange={(e)=>{onSearchInputChange(e, "fromPercent")}} id="fromPercent" keyfilter="int" maxLength={2} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                        <label htmlFor="fromPercent">از درصد تخفیف</label>
                    </FloatLabel>                                                                      
                </Col>
                <Col md={3} style={{marginTop:"20px"}}>
                    <FloatLabel>
                        <InputText value={searchOptions.toPercent} onChange={(e)=>{onSearchInputChange(e, "toPercent")}} id="toPercent" keyfilter="int" maxLength={2} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                        <label htmlFor="toPercent">تا درصد تخفیف</label>
                    </FloatLabel>                                                                      
                </Col>
                <Col md={3} style={{marginTop:"20px"}}>
                    <FloatLabel>
                        <FaDate value={date2} onChange={(val)=>{var ee = {target:{value:String(val)}}; onSearchInputChange(ee, "fromExpireDate")}} />
                        <label htmlFor="fromExpireDate">از تاریخ انقضاء</label>
                    </FloatLabel>                                                    
                </Col>
                <Col md={3} style={{marginTop:"20px"}}>
                    <FloatLabel>
                        <FaDate value={date3} onChange={(val)=>{var ee = {target:{value:String(val)}}; onSearchInputChange(ee, "toExpireDate")}} />
                        <label htmlFor="toExpireDate">تا تاریخ انقضاء</label>
                    </FloatLabel>                                                    
                </Col>
                <Col md={12} style={{marginTop:"30px"}}>
                    <Button label="&nbsp;&nbsp;  جستجو کن  &nbsp;&nbsp;" icon="pi pi-search" onClick={()=>loadItems()} severity="primary" iconPos="right" style={{borderRadius:"5px"}} />
                </Col>
              </Row>
              :<></>
            }

              <Row style={{}}>
                <Col xs={12} md={3}>
                    <table>
                        <tr>
                            <td style={{padding:"5px"}}><Button label="" icon="pi pi-search" onClick={()=>setSearchPanelVisible(!searchPanelVisible)} severity="secondary" iconPos="right" style={{borderRadius:"5px"}} /></td>
                            <td style={{padding:"5px"}}><Button label="" icon="pi pi-download" onClick={()=>exportToExcel()} severity="secondary" iconPos="right"  style={{borderRadius:"5px"}} /></td>
                            <td style={{padding:"5px"}}><Button label="ایجاد کد تخفیف" icon="pi pi-plus" onClick={()=>onAddNewItemClick()} severity="secondary" iconPos="right" style={{borderRadius:"5px"}} /></td>
                        </tr>
                    </table>
                </Col>
              </Row>

              <DataTable value={discounts} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{}} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id">
                {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column> */}
                <Column header="#" headerStyle={{ width: '20px' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="toUserMobile" header={"موبایل"} sortable className="list-cell-text-align"></Column>
                <Column field="tokenPercent" header={"درصد"} sortable className="list-cell-text-align"></Column>
                <Column field="tokenCode" header={"کد تخفیف"} sortable className="list-cell-text-align"></Column>
                <Column field="expireDate" header={"انقضاء"} body={(row, options) => util.SeperateDate(row.expireDate)} sortable className="list-cell-text-align"></Column>
                <Column field="discountTokenState.title" header={"وضعیت"} sortable className="list-cell-text-align"></Column>
                <Column field="useDate" header={"تاریخ استفاده"} body={(row, options) => util.SeperateDate(row.useDate)} sortable className="list-cell-text-align"></Column>
                <Column body={(row, options) => setRowActions(row, options.rowIndex)} exportable={false} style={{ }}></Column>
              </DataTable>

            {
                editFormVisible?
                <Dialog visible={true} style={{ width: '50rem', height:"500px" }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                header="ایجاد کد تخفیف" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => setEditFormVisible(false)}>
                    <Row>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputText value={mobile} onChange={(e)=>{onInputChange(e, "mobile")}} id="title" keyfilter="int" maxLength={11} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                <label htmlFor="firstname">موبایل</label>
                            </FloatLabel>                                                    
                        </Col>
                        <Col md={6} style={{marginTop:"25px"}}>
                            در صورت تکمیل موبایل، کدهای تخفیف تولید شده فقط برای آن شماره موبایل قابل استفاده خواهند بود                                                    
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputText value={count} onChange={(e)=>{onCountChanged(e.target.value)}} id="count" keyfilter="int" maxLength={3} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                <label htmlFor="count">تعداد کد</label>
                            </FloatLabel>                                                    
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputText value={percent} onChange={(e)=>{onPercentChanged(e.target.value)}} id="percent" keyfilter="int" maxLength={2} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                <label htmlFor="percent">درصد تخفیف</label>
                            </FloatLabel>                                                    
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <FaDate value={date} onChange={(val)=>setNewDate(val)} />
                                <label htmlFor="firstname">تاریخ انقضاء</label>
                            </FloatLabel>                                                    
                        </Col>
                    </Row>

                </Dialog>
                :
                <></>
            }
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
            <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
        </>
    )
}